<template>
  <div class="relative filter-checkbox">
    <input
      class="hidden"
      :id="uid"
      :name="name"
      type="checkbox"
      :value="modelValue"
      @input="
        emit('update:modelValue', ($event.target as HTMLInputElement)?.checked)
      "
    />
    <label
      class="rounded-full overflow-hidden flex items-center justify-center cursor-pointer ui-border border-[--filter-bg-color] transition duration-300"
      :class="{
        'text-body-sm clamp-h-10-15 clamp-w-10-15': size === 'sm',
        'text-body-md clamp-h-12-20 clamp-w-12-20': size === 'md',
        'bg-[--filter-bg-color]': modelValue,
        'color-[--filter-bg-color] @hover:bg-[--filter-bg-color] @hover:color-[--filter-text-color]':
          !modelValue,
      }"
      :ariaLabel="label"
      :for="uid"
    >
      <slot>[]</slot>
    </label>
    <ATooltip
      class="tooltip absolute top-50% translate-y-[-50%] translate-x-[-100%] pointer-events-none clamp-left-neg-3-5 opacity-0 transition-all duration-300 color-[--filter-bg-color] w-auto!"
      :label="label"
      size="sm"
    >
      <span class="font-bold text-body-sm whitespace-nowrap">{{ label }}</span>
    </ATooltip>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    name: string;
    label: string;
    id?: string;
    size?: 'sm' | 'md';
  }>(),
  {
    size: 'md',
    checked: false,
  },
);

const emit = defineEmits(['update:modelValue']);

const randomId = `checkbox-${Math.random().toString(16).slice(2)}`;
const uid = computed(() => props.id || randomId);
</script>

<style lang="scss" scoped>
.filter-checkbox {
  @include supports-hover {
    &:hover {
      .tooltip {
        @apply clamp-left-neg-4-6 opacity-100;
      }
    }
  }
}
</style>
